var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUniversalFinanceProvider = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Saving-Bank--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Saving Bank Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.5a1 1 0 0 0 0 -2h-6a1 1 0 0 0 0 2h0.75a0.25 0.25 0 0 1 0.25 0.25v5a0.25 0.25 0 0 1 -0.25 0.25H3.5a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2h-0.75a0.25 0.25 0 0 1 -0.25 -0.25v-5a0.25 0.25 0 0 1 0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.5a1 1 0 0 0 0 -2h-6a1 1 0 0 0 0 2h0.75a0.25 0.25 0 0 1 0.25 0.25v5a0.25 0.25 0 0 1 -0.25 0.25h-0.75a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2h-0.75a0.25 0.25 0 0 1 -0.25 -0.25v-5a0.25 0.25 0 0 1 0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84 6.07a1 1 0 0 0 0.61 1.79h19.2a1 1 0 0 0 0.94 -0.65 1 1 0 0 0 -0.34 -1.15L13.17 0.25A1 1 0 0 0 12 0.18L1.89 6Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.5h21s0.5 0 0.5 0.5v2.5s0 0.5 -0.5 0.5h-21s-0.5 0 -0.5 -0.5V21s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUniversalFinanceProvider);
export default ForwardRef;